import React from "react";
import DataTable from "../../components/DataTable";

const dataJson = [
  {
    id: "df7sd8fs5f",
    level: "01/03/2022",
    cPay: "$45",
    income: "$48878",
  },
  {
    id: "fd7dfs5f",
    level: "01/03/2022",
    cPay: "$45",
    income: "$48878",
  },
  {
    id: "f1d2fs9r",
    level: "01/03/2022",
    cPay: "$45",
    income: "$48878",
  },
  {
    id: "er7er7sfu",
    level: "01/03/2022",
    cPay: "$45",
    income: "$48878",
  },
];

const columns = [
  { id: "level", label: "Level", minWidth: 80 },
  { id: "cPay", label: "C.Pay (%)", minWidth: 50 },
  {
    id: "income",
    label: "Income",
    minWidth: 50,
  },
];

function createData(level, cPay, income) {
  return { level, cPay, income };
}

const rows = dataJson.map((d) => createData(d.level, d.cPay, d.income));

const LevelIncomTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={5}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default LevelIncomTable;
